import React, { Component } from "react";
import { Collapse } from "react-bootstrap"; // Biblioteca opcional
import TableSubData from "./TableSubData";
import TableSubDataRanges from "./TableSubDataRanges"

const labels = {
    Venda: "Revenda",
    Aluguel: "Locação",
};

class Table extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openAccordions: {}, // controle dos accordions
        };
    }

    toggleAccordion = (key) => {
        this.setState((prevState) => ({
            openAccordions: {
                ...prevState.openAccordions,
                [key]: !prevState.openAccordions[key],
            },
        }));
    };

    monetaryFormat = (value) => {
        let doubleFormatter = new Intl.NumberFormat("pt-BR", {
            style: "decimal",
            maximumFractionDigits: 0,
        });

        return doubleFormatter.format(value);
    };

    areaFormat = (value) => {
        let doubleFormatter = new Intl.NumberFormat("pt-BR", {
            style: "decimal",
            maximumFractionDigits: 2,
        });

        return doubleFormatter.format(value);
    };

    render() {
        let totalEmpreendimentos = 0;

        return (
            <div style={{ marginBottom: "40px" }}>
                <table className="table table-striped table-condensed table-padroes">
                    <thead>
                        <tr
                            className="text-center"
                            style={{
                                backgroundColor: this.props.color,
                                color: "#ffffff",
                                fontWeight: "bold",
                            }}
                        >
                            <td colSpan="8">
                                <span style={{ fontWeight: "bold" }}>
                                    {labels[this.props.title]}
                                </span>
                            </td>
                        </tr>
                        <tr
                            className="text-center"
                            style={{
                                backgroundColor: this.props.color,
                                color: "#ffffff",
                                fontWeight: "bold",
                            }}
                        >
                            <th className="text-center" style={{ color: "#ffffff", padding: "7px" }}>Tipo Imóvel</th>
                            <th className="text-center" style={{ color: "#ffffff", padding: "7px" }}>Nº Imóveis</th>
                            <th className="text-center" style={{ color: "#ffffff", padding: "7px" }}>(%)</th>
                            <th className="text-center" style={{ color: "#ffffff", padding: "7px" }}>Área Média Total</th>
                            <th className="text-center" style={{ color: "#ffffff", padding: "7px" }}>Área Média Útil</th>
                            <th className="text-center" style={{ color: "#ffffff", padding: "7px" }}>Preço Médio</th>
                            <th className="text-center" style={{ color: "#ffffff", padding: "7px" }}>Preço Médio M²</th>
                            <th className="text-center" style={{ color: "#ffffff", padding: "7px" }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.metadata.map((index, key) => {
                            totalEmpreendimentos += parseInt(index.total);
                            const isOpen = this.state.openAccordions[key] || false;

                            const icon = isOpen ? <i class='fa-solid fa-arrow-up'></i> : <i class="fa-solid fa-arrow-down"></i>

                            const quartosData = [...this.props.metadataQuartos]
                                .filter((item) => item.tipo === index.tipo)
                                .sort((a, b) => {
                                    const quartosA = a.quartos == null ? 999999 : Number(a.quartos);
                                    const quartosB = b.quartos == null ? 999999 : Number(b.quartos);

                                    return quartosA - quartosB;
                                });
                            const padraoData = this.props.metadataPadrao.filter((item) => item.tipo === index.tipo);
                            const metadataRanges = this.props.metadataRanges ?? [];

                            return (
                                <React.Fragment key={key}>
                                    <tr className="text-center" onClick={() => this.toggleAccordion(key)}>
                                        <td>{icon}{" "}{index.tipo}</td>
                                        <td>{index.total.toLocaleString("pt-BR")}</td>
                                        <td>
                                            {Number(
                                                (index.total * 100) / this.props.count_buildings
                                            )
                                                .toFixed(2)
                                                .toLocaleString()
                                                .replace(".", ",")}
                                            %
                                        </td>
                                        <td>{this.areaFormat(index.media_area_total)}</td>
                                        <td>{this.areaFormat(index.media_area_util)}</td>
                                        <td>{this.monetaryFormat(index.media_preco)}</td>
                                        <td>{this.monetaryFormat(index.media_preco_metro)}</td>
                                    </tr>
                                    {isOpen && (
                                        <tr>
                                            <td colSpan="8">

                                                {quartosData.length > 0 && (
                                                    <>
                                                        <h3 style={{ textAlign: 'center' }}>Oferta por Tipologia</h3>
                                                        <TableSubData
                                                            data={quartosData}
                                                            tipoLabel="Quartos"
                                                            tipoCampo="quartos"
                                                            totalTipo={index.total}
                                                            countBuildings={this.props.count_buildings}
                                                            tipo={index.tipo}
                                                        />
                                                    </>

                                                )}

                                                {this.props.title === 'Venda' && padraoData.length > 0 && (
                                                    <>
                                                        <h3 style={{ textAlign: 'center' }}>Oferta por Padrão</h3>
                                                        <TableSubData
                                                            data={padraoData}
                                                            tipoLabel="Padrão"
                                                            tipoCampo="padrao"
                                                            totalTipo={index.total}
                                                            countBuildings={this.props.count_buildings}
                                                            tipo={index.tipo}

                                                        />
                                                    </>

                                                )}

                                                {metadataRanges && (
                                                    <TableSubDataRanges
                                                        tipo={index.tipo}
                                                        data={this.props.metadataRanges}
                                                    />
                                                )}


                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>Total</td>
                            <td>{totalEmpreendimentos.toLocaleString("pt-BR")}</td>
                            <td>100%</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        );
    }
}

export default Table;
